import pick from 'lodash/pick';

import { digestArtifactContexts } from '../digestArtifactContexts';

import type { EventDefinition } from '../../types';

// `digest_take_action` 1-0-0 (klue-snowplow #218): a curator writes, edits,
// approves or removes a take. Issue takes and story takes share this event —
// the issue always rides an `artifact` entity, and a take on one story
// attaches a second one for the story.
//
// `previous_author_type` is read from the take BEFORE the action, so the
// pair (approved, agent) is the moment a curator put their name to the
// producer's words. The take's text is application data in stak.
export const digest_take_action: EventDefinition = {
  getData: (action, eventData = {}) => ({
    action,
    ...pick(eventData, ['previous_author_type']),
  }),
  addContexts: digestArtifactContexts,
};
